import Text from 'common/ui/Text';
import { Stack } from 'common/ui/Layout';
import { css } from 'styled-components';
import { Colors } from 'styles';
import React from 'react';
import { HPDivider } from './hpStyles';
export interface MatchingDescriptionsTableProps {
  descriptions: readonly string[];
  backgroundColor?: string;
}

export const MatchingDescriptionsTable = ({ descriptions }: MatchingDescriptionsTableProps) => {
  return (
    <div
      css={css`
        height: 100%;
      `}
    >
      {descriptions.map((description, index) => (
        <React.Fragment key={index}>
          <Stack
            alignY="center"
            css={css`
              padding: 8px 1rem;
            `}
          >
            <Text
              css={css`
                flex: 1;
                color: ${Colors.gray10};
                line-height: 16px;
              `}
              data-testid={`matching-description-${index}`}
            >
              {description}
            </Text>
          </Stack>
          {index < descriptions.length - 1 && <HPDivider />}
        </React.Fragment>
      ))}
    </div>
  );
};
